// @flow

export default function paymentMethodUrl() {
  return '/payment_methods'
}
